<template>
  <v-toolbar app height="60">
    <v-layout row align-center>
      <v-flex xs4 class="text-xs-left">
        <v-badge right color="red" :value="cartTotalQuantity > 0">
          <template v-slot:badge>
            <span>{{cartTotalQuantity}}</span>
          </template>
          <v-icon left flat style="margin-right:0px;">shopping_basket</v-icon>
        </v-badge>
      </v-flex>
      <v-flex xs4>
        <v-card-actions class="justify-center">
        <v-img
          :src="require('@/assets/attire_logo.png')"
          max-width="75"
          @click="$router.push('/')"
          style="cursor:pointer;"
        ></v-img>
        </v-card-actions>
      </v-flex>
      <v-flex xs4 text-xs-right>
        <v-menu offset-y v-if="logged && logged.user">
          <template v-slot:activator="{ on }">
            <!-- <v-btn color="primary" dark v-on="on" round outline>My Account</v-btn> -->
            <v-icon v-on="on">account_circle</v-icon>
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in myAccountMenuItems"
              :key="index"
              @click="item.router_name == 'my_account_logout' ? onLoggedOutClicked() : $router.push({ name: item.router_name })"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-icon v-else @click="$store.commit('common/setIsLoginFormModal', true)">account_circle</v-icon>
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "App",
  components: {},
  data() {
    return {
      myAccountMenuItems: [
        { title: "My Profile", router_name: "my_account_profile" },
        { title: "My Orders", router_name: "my_account_my_orders" },
        { title: "Track My Order", router_name: "my_account_track_my_orders" },
        { title: "Logout", router_name: "my_account_logout" }
      ]
    };
  },
  computed: {
    ...mapGetters("cart", {
      // cartProducts: "cartProducts",
      cartTotalQuantity: "cartTotalQuantity"
    })
  },
  methods: {
    onLoggedOutClicked() {
      this.$store.commit("common/setLogged", {});
      this.$router.push({ name: "home" });
    }
  }
};
</script>
